import { render, staticRenderFns } from "./notifmigrationpab.vue?vue&type=template&id=f39ea6fa&scoped=true&"
import script from "./notifmigrationpab.vue?vue&type=script&lang=js&"
export * from "./notifmigrationpab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39ea6fa",
  null
  
)

export default component.exports